// 教师状态管理模块
const state = {
  schedule: [],
  students: [],
  ratings: []
};

const mutations = {
  SET_SCHEDULE(state, schedule) {
    state.schedule = schedule;
  },
  SET_STUDENTS(state, students) {
    state.students = students;
  },
  SET_RATINGS(state, ratings) {
    state.ratings = ratings;
  },
  ADD_RATING(state, rating) {
    state.ratings.push(rating);
  }
};

const actions = {
  fetchSchedule({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const schedule = [
          { id: 1, className: '三年级一班', subject: '数学', day: '周一', time: '8:00-9:30', room: '教室A101' },
          { id: 2, className: '三年级二班', subject: '数学', day: '周二', time: '10:00-11:30', room: '教室A102' },
          { id: 3, className: '四年级一班', subject: '数学', day: '周三', time: '13:00-14:30', room: '教室B201' }
        ];
        commit('SET_SCHEDULE', schedule);
        resolve(schedule);
      }, 500);
    });
  },
  fetchStudents({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const students = [
          { id: 1, name: '张三', age: 9, grade: '三年级', className: '一班', avatar: 'https://randomuser.me/api/portraits/children/1.jpg' },
          { id: 2, name: '李四', age: 9, grade: '三年级', className: '一班', avatar: 'https://randomuser.me/api/portraits/children/2.jpg' },
          { id: 3, name: '王五', age: 10, grade: '四年级', className: '一班', avatar: 'https://randomuser.me/api/portraits/children/3.jpg' }
        ];
        commit('SET_STUDENTS', students);
        resolve(students);
      }, 500);
    });
  },
  submitRating({ commit }, ratingData) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const rating = {
          id: Date.now(),
          ...ratingData,
          timestamp: new Date().toISOString()
        };
        commit('ADD_RATING', rating);
        resolve(rating);
      }, 500);
    });
  }
};

const getters = {
  schedule: state => state.schedule,
  students: state => state.students,
  ratings: state => state.ratings
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 